import React, { useState, useEffect, useContext } from 'react';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom'
import './Navbar.css';
import axios from 'axios'; 
import logo from '../Assets/logo.jpg';
import cart_icon from '../Assets/cart_icon.png';
import { Link, useLocation } from 'react-router-dom';
import { ShopContext } from '../../Context/ShopContext';

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();  // Get current route
    const { getTotalCartItems } = useContext(ShopContext); 
    const [user, setUser] = useState({});
    const [profile, setProfile] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Function to determine active menu based on the current path
    const getMenuFromPath = (path) => {
        if (path.startsWith("/grocery")) return "grocery";
        if (path.startsWith("/spices")) return "spices";
        if (path.startsWith("/beverages")) return "drinks";
        if (path.startsWith("/ricemix")) return "ricemix";
        if (path.startsWith("/misc")) return "misc";
        return "shop";  // Default to "shop"
    };

    const [menu, setMenu] = useState(getMenuFromPath(location.pathname));

    // Ensure menu updates correctly when URL changes
    useEffect(() => {
        setMenu(getMenuFromPath(location.pathname));
    }, [location.pathname]);

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => setUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });

    useEffect(() => {
        const loggedInUser = localStorage.getItem("user");
        if (loggedInUser) {
            setProfile(JSON.parse(loggedInUser));
        } else if (user && Object.keys(user).length > 0) {
            axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${user.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then((res) => {
                    setProfile(res.data);
                    localStorage.setItem('user', JSON.stringify(res.data));
                    window.location.reload(true);
                })
                .catch((err) => console.log(err));
        }
    }, [user]);

    const logout = () => {
        googleLogout();
        setProfile(null);
        localStorage.clear();
        navigate('/', { replace: true });
        window.location.reload(true);
    };

    // Toggle mobile menu visibility
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <div className="navbar">
            <div className="nav-logo">
                <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                    <img src={logo} alt="Logo" />
                    <p>Sairam Foods</p>
                </Link>
            </div>

            {/* Hamburger Icon (mobile) */}
            <div className="nav-toggle" onClick={toggleMobileMenu}>
                <div className={`line ${mobileMenuOpen ? 'open' : ''}`} />
                <div className={`line ${mobileMenuOpen ? 'open' : ''}`} />
                <div className={`line ${mobileMenuOpen ? 'open' : ''}`} />
            </div>

            {/* Nav Menu */}
            <ul className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
                <li className={menu === "shop" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/">Shop</Link>
                </li>
                <li className={menu === "grocery" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/grocery">Grocery</Link>
                </li>
                <li className={menu === "spices" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/spices">Spices</Link>
                </li>
                <li className={menu === "drinks" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/beverages">Beverages</Link>
                </li>
                <li className={menu === "ricemix" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/ricemix">Rice Mix</Link>
                </li>
                <li className={menu === "misc" ? "active" : ""} onClick={() => setMobileMenuOpen(false)}>
                    <Link to="/misc">Misc</Link>
                </li>
            </ul>

            <div className="nav-login-cart">
                <span>{profile ? <p>Hi, {profile.name}</p> : ''}</span>
                <span>
                    {profile ? <button onClick={logout}>Logout</button> : <button onClick={login}>Login</button>}
                </span>
                {profile ? <Link to="/myorders">My Orders</Link> : ""}
                <Link to="/cart"><img src={cart_icon} alt="Cart" /></Link>
                <div className="nav-cart-count">{getTotalCartItems()}</div>
            </div>
        </div>
    );
};

export default Navbar;
